import { encryption_key } from 'config/encryptionConfig';
import SimpleCrypto from 'simple-crypto-js';

const secretKey = encryption_key || '';
// const secretKey = process.env.REACT_APP_ENCRYPTION_KEY;
const simpleCrypto = new SimpleCrypto(secretKey);
export const encryptResult = (data: string): string => {
    return simpleCrypto.encrypt(data);
};

export const decryptResult = (encryptedData: string): any => {
  return simpleCrypto.decryptObject(encryptedData);
};